import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 51px;
    display: flex;
    align-items: center;
    background-color: white;
    padding-left: 15px;
    cursor: pointer;

    &:hover {
      background-color: ${`${theme?.colour?.primary}0D`};
    }
  `}
`;